import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Gift } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

/** Word-of-mouth block: how private-pay care actually spreads. */
const ReferralOffer = () => (
  <section className="py-16 md:py-20 bg-accent/30" aria-labelledby="referral-heading">
    <div className="container">
      <div className="max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-background mb-4">
          <Gift className="h-5 w-5 text-warm-ink" aria-hidden />
        </div>
        <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-warm-ink mb-3 font-medium">Referral Program</p>
        <h2 id="referral-heading" className="text-2xl md:text-3xl font-heading font-semibold mb-4">
          Know a family who needs this? You both get $100.
        </h2>
        <div className="w-12 h-px bg-warm mx-auto mb-6" />
        <p className="text-foreground/75 font-light leading-relaxed mb-7 max-w-2xl mx-auto">
          When someone you refer completes their first month of care, we credit them $100 and
          send you $100. No forms, no codes — they simply mention your name.
        </p>
        <Button asChild size="lg" onClick={() => trackEvent("referral_cta_click", { location: "referral_block" })}>
          <Link to="/refer">How the referral program works</Link>
        </Button>
      </div>
    </div>
  </section>
);

export default ReferralOffer;
